import { render, staticRenderFns } from "./LawMatterEvidenceDetectionCounterPartyForm.vue?vue&type=template&id=60cde344&"
import script from "./LawMatterEvidenceDetectionCounterPartyForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterEvidenceDetectionCounterPartyForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterEvidenceDetectionCounterPartyForm.vue?vue&type=style&index=0&id=60cde344&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports